import { render, staticRenderFns } from "./agingpinjaman_wo30sep19.vue?vue&type=template&id=0037775b&"
import script from "./agingpinjaman_wo30sep19.vue?vue&type=script&lang=js&"
export * from "./agingpinjaman_wo30sep19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports